import { PayloadAction, createSlice } from '@reduxjs/toolkit';

export const PLANT_FEATURE_KEY = 'plant';

type PlantState = {
  selectedPlantId: string | null;
};

const initialState: PlantState = {
  selectedPlantId: null,
};

export const plantSlice = createSlice({
  name: PLANT_FEATURE_KEY,
  initialState,
  reducers: {
    setSelectedPlantId: (state, { payload }: PayloadAction<string | null>) => {
      state.selectedPlantId = payload;
    },
  },
});

export const { setSelectedPlantId } = plantSlice.actions;

export const plantReducer = plantSlice.reducer;
